import { useAccessibilityMenuStore } from "@eg_ui/src/stores/accessibilityMenuStore";
import { GLOBAL_EVENTS, globalEventHandler } from "@eg_ui/src/utils/libs";
import { mapStores } from "pinia";

export const accessibilityMenu = {
    computed: {
        ...mapStores(useAccessibilityMenuStore),
    },
    methods: {
        tabOnMainContainer(e) {
            if (this.accessibilityMenuStore.keyboardTabLocation) {
                globalEventHandler.emit(
                    GLOBAL_EVENTS.FEED_TILE.FOCUS_ON_TILE,
                    this.accessibilityMenuStore.keyboardTabLocation,
                );
                e.preventDefault();
                this.accessibilityMenuStore.keyboardTabLocation = "";
            }
        },
    },
};
